module.exports = __webpack_public_path__ + "img/1495917646.ccdb93ae.jpg";